import { HiddenEvaluator } from '@/types/filter';

const shouldHideTerritoryFilter: HiddenEvaluator = ({ contexts: { userInfo } }) => {
  const countriesExcludingTerritory = ['FI', 'DK', 'SE', 'NO'];

  return (
    userInfo.countries.length > 0 && userInfo.countries.every(group => countriesExcludingTerritory.includes(group))
  );
};

export default shouldHideTerritoryFilter;
